// src/providers/GoogleMapsProvider.tsx
import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_PLACE_API } from "../store/constant";

interface GoogleMapsContextProps {
  isLoaded: boolean;
}

const GoogleMapsContext = createContext<GoogleMapsContextProps>({
  isLoaded: false,
});

export const GoogleMapsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_PLACE_API,
    libraries: ["places", "geometry"], 
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);
